import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/index.vue'
import Party from "@/pages/party/party.vue"

import NewsIndex from "@/pages/news/index"
import NewsList from "@/pages/news/list"
import NewsInfo from "@/pages/news/info"
import NewsFace from "@/pages/news/news"


// 会员服务
import MemberIndex from "@/pages/member/index"
import MemberService from "@/pages/member/service"
import MemberServiceInfo from "@/pages/member/info"
import MemberView from "@/pages/member/view"
// 融资服务
import FinancingIndex from "@/pages/financing/index"
import FinancingService from "@/pages/financing/service"
import FinancingServiceInfo from "@/pages/financing/info"

// 公司服务
import CompanyIndex from "@/pages/company/index"
import CompanyService from "@/pages/company/service"
import CompanyServiceInfo from "@/pages/company/info"
import CompanyView from "@/pages/company/view"

import Property from "@/pages/property/property"

import About from "@/pages/about/about"

import Train from "@/pages/train/train"


import SearchNews from "@/pages/search/searchNews"

//培训路演
import RoadShowRoute from "@/pages/roadshow/index"
import RoadShowIndex from "@/pages/roadshow/roadshow"
import RoadShowList from "@/pages/roadshow/list"
import RoadShowInfo from "@/pages/roadshow/info"
import RoadShowLast from "@/pages/roadshow/last"


//业务详情
import Business from "@/pages/business/business"

import SpecialInfo from "@/pages/special/info"
import Information from "@/pages/special/information"

//boss
import BossIndex from "@/pages/boss/index"

//上市服务联盟
import Alliance from "@/pages/alliance/index"

//专精特新
import Refined from "@/pages/refined/index"

import path from "path";

Vue.use(Router)
//

export default new Router({
  scrollBehavior(to, from, savedPosition) { //解决路由跳转后不置顶问题
    if(!to.matched[0].meta.childDisScroll){ //判断路由的父路由childDisScroll为true则刷新该页面不置顶，
      if (savedPosition) {
        return savedPosition
      }
      return {
        x: 0,
        y: 0
      }
    }
  },
  mode:"hash",
  base: process.env.BASE_URL,
	routes: [{
			path: '/',
			name: 'Index',
			component: Index,
		},
		{
			path: "/business",
			name: "Business",
			component: Business
		},
		{
			path: "/special/info/:id",
			name: "SpecialInfo",
			component: SpecialInfo
		},
		{
			path: "/searchNews",
			name: "SearchNews",
			component: SearchNews
		},
		{
			path:"/information",
			name:Information,
			component:Information
		},
		{
			path: "/party",
			name: "Party",
			component: Party,
		}, {
			path: "/news",
			name: "NewsIndex",
			component: NewsIndex,
			redirect: "/news/face",
			children: [{
				path: "/news/face",
				name: "NewsFace",
				component: NewsFace,
			}, {
				path: "/news/list",
				name: "NewsList",
				component: NewsList,
			}, {
				path: "/news/info",
				name: "NewsInfo",
				component: NewsInfo
			}]
		}, {
			path: "/company",
			name: "CompanyIndex",
			component: CompanyIndex,
			redirect: "/company/service",
			children: [{
				path: "/company/service",
				name: "CompanyService",
				component: CompanyService,

			}, {
				path: "/company/serviceInfo/:id",
				name: "CompanyServiceInfo",
				component: CompanyServiceInfo
			}, {
				path: "/company/view",
				name: "CompanyView",
				component: CompanyView
			}]
		}, {
			path: "/member",
			name: "MemberIndex",
			component: MemberIndex,
			redirect: "/member/service",
			children: [{
				path: "/member/service",
				name: "MemberService",
				component: MemberService,

			}, {
				path: "/member/serviceInfo/:id",
				name: "MemberServiceInfo",
				component: MemberServiceInfo
			}, {
				path: "/member/view",
				name: "MemberView",
				component: MemberView
			}]
		}, {
			path: "/financing",
			name: "FinancingIndex",
			component: FinancingIndex,
			redirect: "/financing/service",
			children: [{
				path: "/financing/service",
				name: "FinancingService",
				component: FinancingService,

			}, {
				path: "/financing/serviceInfo/:id",
				name: "FinancingServiceInfo",
				component: FinancingServiceInfo
			}]
		}, {
			path: "/property",
			name: "Property",
			component: Property
		}, {
			path: "/about",
			name: "About",
			component: About
		}, {
			path: "/train",
			name: "Train",
			component: Train
		}, {
			path: "/roadshow",
			name: "RoadShow",
			component: RoadShowRoute,
			redirect: "/roadshow/face",
			children: [{
					path: "/roadshow/face",
					name: "RoadShowFace",
					component: RoadShowIndex,
				},
				{
					path: "/roadshow/last",
					name: "RoadShowLast",
					component: RoadShowLast
				},
				{
					path: "/roadshow/list",
					name: "RoadShowList",
					component: RoadShowList,
				},
				{
					path: "/roadshow/info",
					name: "RoadShowInfo",
					component: RoadShowInfo,
				},
			]
		},
		{
			path:"/boss",
			name:"BossIndex",
			component:BossIndex
		},
		{
			path:"/alliance",
			name:"Alliance",
			component:Alliance
		},
		{
			path:"/alliance/news-detail",
			name:"AllianceNewsDetail",
			component: () => import("@/pages/alliance/news-detail")	
		},
		
		{
			path:"/refined",
			name:"Refined",
			component:Refined
		},
		{
			path:"/activity/detail",
			name:"activityDetail",
			component: () => import("@/pages/refined/activity-detail")
		},
		// 一键入板
		{
			path:"/refined/sensible",
			name:"sensible",
			component: () => import("@/pages/refined/sensible/index")
		},
		//手机号验证码
		{
			path:"/refined/sensible/verify",
			name:"sensibleVerify",
			component: () => import("@/pages/refined/sensible/verify")
		},
		// 一键入板获取工商信息表单
		{
			path:"/refined/sensible/form",
			name:"sensibleForm",
			component: () => import("@/pages/refined/sensible/form")
		},
		{
			path:"/refined/sensible/result",
			name:"refinedResult",
			component: () => import("@/pages/refined/sensible/result")
		},
		//上市测评
		{
			path:"/refined/listing",
			name:"listing",
			component: () => import("@/pages/refined/listing/index")
		},
		//上市测评
		{
			path:"/refined/alliance",
			name:"refinedalliance",
			component: () => import("@/pages/refined/alliance/index")
		},
		// 专精测评
		{
			path:"/refined/assess",
			name:"assess",
			component: () => import("@/pages/refined/assess/index")
		},
		//手机号验证码
		{
			path:"/refined/assess/verify",
			name:"assessVerify",
			component: () => import("@/pages/refined/assess/verify")
		},
		// 专精测评做题
		{
			path:"/refined/assess/form",
			name:"assess",
			component: () => import("@/pages/refined/assess/form")
		},
		// 专精测评做题分数结果
		{
			path:"/refined/assess/result",
			name:"assess",
			component: () => import("@/pages/refined/assess/result")
		}
	]

})



// WEBPACK FOOTER //
// ./src/router/index.js